module.exports = __webpack_public_path__ + "static/media/404.1b372662.png";